import type { FiboSuggestionItem } from '../../../model';
import type { Currency } from '../../../constants';

export type FiboSearchRequest = {
  s: string;
  currency?: Currency;
};

export type FiboSearchResponse = {
  suggestions: FiboSuggestionItem[];
  total: number;
  tntTime: string;
  time: string;
  engine: string;
  v: string;
};

// Wire types for GET /search/autocomplete (Meilisearch-backed)

export type AutocompleteGroupItem = {
  id: string;
  value: string;
  parent?: string;
  url: string;
  breadcrumbs?: string;
  score?: number;
};

export type AutocompleteProductItem = {
  productId: string;
  name: string;
  brand: string;
  imageUrl: string;
  url: string;
  minPrice: number;
  maxPrice: number;
  currency: string;
  inStock: boolean;
  onSale: boolean;
  sku: string;
};

export type SearchAutocompleteResponse = {
  query: string;
  groups: {
    brands: AutocompleteGroupItem[];
    categories: AutocompleteGroupItem[];
    tags: AutocompleteGroupItem[];
    products: AutocompleteProductItem[];
  };
};
